var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 40 40",
    viewBox: "0 0 40 40",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GitHub"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Soundcloud_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dropbox_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Instagram_7_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "WordPress_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PlayStation"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XBox_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Windows_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "iOS_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Apple_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Android_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Deviantart_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Yelp_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Picassa_6_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LastFM_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Amazon_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AIM_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fffound_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Forrst_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Yahoo_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "YouTube_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Behance_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 2,
    width: 7,
    x: 24.5,
    y: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4,19.3c1.5-0.7,2.3-1.9,2.3-3.5c0-3.1-2.2-4.3-5.3-4.3H6.5v17h8.1c3,0,5.9-1.5,5.9-4.9    C20.5,21.5,19.5,19.9,17.4,19.3z M9.9,14.3h3.8c1.3,0,2.5,0.3,2.5,1.9c0,1.4-1,2-2.2,2h-4V14.3z M14.1,25.8H9.9v-4.6h4.3    c1.6,0,2.5,0.7,2.5,2.4C16.7,25.3,15.6,25.8,14.1,25.8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6,15.8c-3.7,0-6.2,2.7-6.2,6.3c0,3.7,2.4,6.3,6.2,6.3c2.7,0,4.9-1.5,5.8-4.3h-2.9    c-0.2,0.7-1.4,1.8-2.8,1.8c-1.9,0-2.9-1.3-3-3.4h8.8C33.7,18.9,31.7,15.8,27.6,15.8z M24.7,20.4c0-0.9,0.7-2.1,2.8-2.1    c1.6,0,2.3,0.4,2.7,2.1H24.7z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tumblr_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vimeo_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skype_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pinterest_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dribbble_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flickr_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Google_Plus_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RSS_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Twitter_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Facebook_2_"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lockup"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.3a376c7c8988a54404a9c4268c45e6db.svg";
export { ForwardRef as ReactComponent };